export enum PVFileFormatRef {
  hysize = 'hysize',
  pvsim = 'pvsim',
  pvsyst = 'pvsyst',
  helioscope = 'helioscope'
}

export enum PVFileDurationRef {
  year_1 = 'year_1',
  week_1 = 'week_1',
  week_2 = 'week_2'
}

export enum PVFileStepRef {
  minute_1 = 'minute_1',
  minute_5 = "minute_5",
  minute_10 = 'minute_10',
  minute_15 = 'minute_15',
  minute_30 = 'minute_30',
  hour_1 = 'hour_1'
}

export class PVFileReferenceUtils {

  public static getNumberOfHoursPerDuration(duration: PVFileDurationRef): number {
    switch (duration) {
      case PVFileDurationRef.week_1: return 7 * 24;
      case PVFileDurationRef.week_2: return 2 * 7 * 24;
      case PVFileDurationRef.year_1: return 365 * 24;
      default: throw new Error('How did you get there ?!');
    }
  }

  public static getNumberOfValuesPerHour(step: PVFileStepRef): number {
    switch (step) {
      case PVFileStepRef.minute_1: return 60;
      case PVFileStepRef.minute_5: return 12;
      case PVFileStepRef.minute_10: return 6;
      case PVFileStepRef.minute_15: return 4;
      case PVFileStepRef.minute_30: return 2;
      case PVFileStepRef.hour_1: return 1;
      default: throw new Error('How did you get there ?!');
    }
  }
}
